<template>
  <div class="view-authentication">
    <div class="view-authentication-left">
      <div class="view-authentication-content">
        <h1 style="margin-bottom: var(--spacer-2)">Bienvenue sur l'outil<br />Sopravision</h1>
        <form class="authentication-form" action="#" @submit.prevent="onAuthenticate">
          <InputCommon bordered v-model="input_tenant" label="Tenant" />
          <InputCommon bordered v-model="input_login" label="Login" />
          <InputCommon bordered type="password" v-model="input_password" label="Mot de passe" />
          <input class="submit" type="submit" value="Se connecter" />
        </form>
      </div>
    </div>
    <div v-if="breakpoints.isGreater('tablet')" class="view-authentication-right" style="">
      <img class="authentication-image" :src="ToitSoprema"></img>
    </div>
  </div>
</template>

<script setup lang="ts">
import InputCommon from '@/components/common/input/InputCommon.vue'
import { application_breakpoints } from '@/service/service_breakpoints'
import { useSecurityStore } from '@/stores/store_security'
import { useBreakpoints } from '@vueuse/core'
import  ToitSoprema  from '@/assets/images/soprema-building.jpg'

import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const store = useSecurityStore()
const breakpoints = useBreakpoints(application_breakpoints)
const input_tenant = ref('')
const input_login = ref('')
const input_password = ref('')
const route = useRoute()
const router = useRouter()

function onAuthenticate() {
  store
    .authenticate(
      input_tenant.value,
      input_login.value,
      input_password.value,
      route.redirectedFrom?.fullPath
    )
    .then(() => {
      router.push('/dashboard')
    })
}

onMounted(() => {
  if (store.isAuthenticated) {
    router.push('/dashboard')
  }
})
</script>

<style scoped>
.authentication-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.authentication-form > .submit {
  padding: 10px;
  margin-top: 20px;
}

.view-authentication {
  display: flex;
  height: 100vh;
}

.view-authentication-left {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.view-authentication-right {
  height: 100%;
  width: 50%;
  background-color: var(--vc-secondary);
}

.view-authentication-content {
  padding: var(--spacer-2);
}

.authentication-image {
  height: 100%;
  width: auto;
  object-fit: cover;
}

input[type='submit'] {
  transition: 600ms cubic-bezier(0.19, 1, 0.22, 1);
  width: 100%;
  background-color: var(--vc-primary);
  color: var(--vc-white);
  font-weight: 600;
  border-radius: var(--spacer);
  border: 1px solid var(--vc-gray2);
  cursor: pointer;
}

input[type='submit']:hover {
  transition: 600ms cubic-bezier(0.19, 1, 0.22, 1);
  background-color: var(--vc-white);
  border: 1px solid var(--vc-gray2);
  color: var(--vc-primary);
}

input:-webkit-autofill {
  color: #999 !important;
}
</style>
